import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlConsultaOrdemCronologicaPagamento = '/service/contabilidade/ordemCronologicaPortal/'

class ConsultaOrdemCronologicaPagamentoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            exercicio: filtro.exercicio,
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            situacao: filtro.situacao.length > 0 ? filtro.situacao.map(e => e.value).join() : null,
            pagos: filtro.pagos ? filtro.pagos.value : null,
            nomeCredor: filtro.nomeCredor ? filtro.nomeCredor : null,
            cnpj: filtro.cnpj ? filtro.cnpj.replace(/^(\d{2}).(\d{3}).(\d{3})\/(\d{4})-(\d{2})/, '$1$2$3$4$5') : null,
            cpf: filtro.cpf ? filtro.cpf.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4') : null,
            dataVencimentoInicial: filtro.dataVencimentoInicial ? moment(filtro.dataVencimentoInicial).format() : null,
            dataVencimentoFinal: filtro.dataVencimentoFinal ? moment(filtro.dataVencimentoFinal).format() : null,
            dataPagamentoInicial: filtro.dataPagamentoInicial ? moment(filtro.dataPagamentoInicial).format() : null,
            dataPagamentoFinal: filtro.dataPagamentoFinal ? moment(filtro.dataPagamentoFinal).format() : null,
            dataDocumentoInicial: filtro.dataDocumentoInicial ? moment(filtro.dataDocumentoInicial).format() : null,
            dataDocumentoFinal: filtro.dataDocumentoFinal ? moment(filtro.dataDocumentoFinal).format() : null,
            valorLiquidacaoInicial: filtro.valorLiquidacaoInicial ? filtro.valorLiquidacaoInicial.replace('.', '').replace(',', '') : null,
            valorLiquidacaoFinal: filtro.valorLiquidacaoFinal ? filtro.valorLiquidacaoFinal.replace('.', '').replace(',', '') : null,
            documento: filtro.documento ? filtro.documento : null,
            serieDocumento: filtro.serieDocumento ? filtro.serieDocumento : null,
            grupos: filtro.grupos.length > 0 ? filtro.grupos.map(e => e.value).join() : null,
            recurso: filtro.recurso.length > 0 ? filtro.recurso.map(e => e.value).join() : null,
            destinacao: filtro.destinacao.length > 0 ? filtro.destinacao.map(e => e.value).join() : null,
            numeroContrato: filtro.numeroContrato ? filtro.numeroContrato : null,
            objetoContrato: filtro.objetoContrato ? filtro.objetoContrato : null,
        }

        return this.conex.post(urlConsultaOrdemCronologicaPagamento + 'consultaOrdemCronologicaPagamento/', JSON.stringify(data))
    }

    consultarMP(filtro, grupos) {
        let data = {
            exercicio: filtro.exercicio,
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            situacao: filtro.situacao.length > 0 ? filtro.situacao.map(e => e.value).join() : null,
            pagos: filtro.pagos ? filtro.pagos.value : null,
            nomeCredor: filtro.nomeCredor ? filtro.nomeCredor : null,
            cnpj: filtro.cnpj ? filtro.cnpj.replace(/^(\d{2}).(\d{3}).(\d{3})\/(\d{4})-(\d{2})/, '$1$2$3$4$5') : null,
            cpf: filtro.cpf ? filtro.cpf.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4') : null,
            dataVencimentoInicial: filtro.dataVencimentoInicial ? moment(filtro.dataVencimentoInicial).format() : null,
            dataVencimentoFinal: filtro.dataVencimentoFinal ? moment(filtro.dataVencimentoFinal).format() : null,
            dataPagamentoInicial: filtro.dataPagamentoInicial ? moment(filtro.dataPagamentoInicial).format() : null,
            dataPagamentoFinal: filtro.dataPagamentoFinal ? moment(filtro.dataPagamentoFinal).format() : null,
            dataDocumentoInicial: filtro.dataDocumentoInicial ? moment(filtro.dataDocumentoInicial).format() : null,
            dataDocumentoFinal: filtro.dataDocumentoFinal ? moment(filtro.dataDocumentoFinal).format() : null,
            valorLiquidacaoInicial: filtro.valorLiquidacaoInicial ? filtro.valorLiquidacaoInicial.replace('.', '').replace(',', '') : null,
            valorLiquidacaoFinal: filtro.valorLiquidacaoFinal ? filtro.valorLiquidacaoFinal.replace('.', '').replace(',', '') : null,
            documento: filtro.documento ? filtro.documento : null,
            serieDocumento: filtro.serieDocumento ? filtro.serieDocumento : null,
            recurso: filtro.recurso.length > 0 ? filtro.recurso.map(e => e.value).join() : null,
            destinacao: filtro.destinacao.length > 0 ? filtro.destinacao.map(e => e.value).join() : null,
            numeroContrato: filtro.numeroContrato ? filtro.numeroContrato : null,
            objetoContrato: filtro.objetoContrato ? filtro.objetoContrato : null,
            grupos: grupos ? grupos : null,
        }

        return this.conex.post(urlConsultaOrdemCronologicaPagamento + 'ordemCronologicaPagamentoExterno/', JSON.stringify(data))
    }
}

export default ConsultaOrdemCronologicaPagamentoService
